$(document).on('turbo:load', function() {
  $('.collapse.in').addClass('shown');
  $('.collapse').on('shown', function() {
    $(this).addClass('shown');
  });
  return $('.collapse').on('hide', function() {
    $(this).removeClass('shown');
  });
});
